var classes = {
  "root": "m_cf365364",
  "indicator": "m_9e182ccd",
  "label": "m_1738fcb2",
  "input": "m_1714d588",
  "control": "m_69686b9b",
  "innerLabel": "m_78882f40"
};
export { classes as default };